import { graphql, useMutation } from "react-relay";
import { SetStatusFN } from "./statusCoordinator";
import { useCallback } from "react";
import { useDebouncedMutation } from "../../../../../common/Utils/useDebouncedMutation";
import { useWorkspaceSignalEditSetTitleMutation } from "./__generated__/useWorkspaceSignalEditSetTitleMutation.graphql";

const key = "set_title";
export function useSignalEditSetTitle(
  id: string,
  remoteTitle: string,
  setStatus: SetStatusFN
) {
  const [updateTitle, loading] =
    useMutation<useWorkspaceSignalEditSetTitleMutation>(graphql`
      mutation useWorkspaceSignalEditSetTitleMutation(
        $id: ID!
        $title: String!
      ) {
        signalWorkspace(id: $id) {
          updateTitle(newTitle: $title) {
            id
            title
            ...WorkspaceSignalEditMainEditedInfo_Signal
          }
        }
      }
    `);

  const saveTitle = useCallback(
    (title: string) =>
      updateTitle({
        onError: () => setStatus(key, "error"),
        onCompleted: () => setStatus(key, "saved"),
        variables: {
          id,
          title,
        },
      }),
    [id, setStatus, updateTitle]
  );

  return [
    ...useDebouncedMutation(remoteTitle, saveTitle, 500, undefined, () =>
      setStatus(key, "saving")
    ),
    loading,
  ] as const;
}
